import { render } from "./CaseShow.vue?vue&type=template&id=8f7e16f2&scoped=true"
import script from "./CaseShow.vue?vue&type=script&lang=js"
export * from "./CaseShow.vue?vue&type=script&lang=js"

import "./CaseShow.vue?vue&type=style&index=0&id=8f7e16f2&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7e16f2"]])

export default __exports__